import { LocalStorageService } from '@/src/services/LocalStorageService'
import { ReactNode, useCallback, useEffect, useState } from 'react'
import { Props } from './Layout'
import { updatedAtKey } from './texts'

export type Params = {
  children: ReactNode
}

export const useProps = ({ children }: Params): Props => {
  const [visibleAgreement, setVisibleAgreement] = useState(false)

  useEffect(() => {
    setVisibleAgreement(LocalStorageService.loadPrivacyPolicyAgreementKey() !== updatedAtKey)
  }, [])

  const onClickAgree = useCallback(() => {
    setVisibleAgreement(false)
    LocalStorageService.savePrivacyPolicyAgreementKey(updatedAtKey)
  }, [])
  return {
    visible: visibleAgreement,
    onClickAgree,
    children,
  }
}
